import React from 'react'

function SingleProduct() {
  return (
    <div>
      
    </div>
  )
}

export default SingleProduct;
